{
    "DefaultSet_Standard_Reports": "Standardberichte",
    "DefaultSet_Power_User_Reports": "Power-User-Berichte",
    "DefaultSet_Contact_Centre_Reports": "Contact Center-Berichte",
    "DefaultSet_Call_Centre_Reports": "Callcenter-Berichte",
    "DefaultSet_SIP_Reports": "SIP-Berichte",
    "NAME": "ReportingDefaultReportSets",
    "DefaultSet_Enhanced_Call_Centre_Reports": "Erweiterte Call-Center-Berichte",
    "DefaultSet_Call_Centre_Agent_Reports": "Call Center Agent Berichte",
    "DefaultSet_Essentials_Reports_MST": "CXA-Standardberichte",
    "DefaultSet_Professional_Reports_MST": "Nicht verwendete CXA-Berichte",
    "DefaultSet_Call_Centre_Agent_Reports_MST": "CXA Premium-Berichte",
    "DefaultSet_Call_Center_Reports": "Call-Center-Berichte",
    "DefaultSet_Enhanced_Call_Center_Reports": "Erweiterte Call-Center-Berichte"
}